<template>
  <div class="logo">
      <div class="logo-content" @click="logoClick">
        <!-- <img src="../../../static/images/logo.png" alt=""> -->
        <p class="protalName">微能力“四应用”活动</p>
        <!-- <p class="protalName" @click="toProtal()">{{topTitle}}</p> -->
      </div>
  </div>
</template>

<script>

export default {
  name: 'Logo',
  data () {
    return {
      topTitle: ''
    };
  },
  created () {
    // this.topTitle = JSON.parse(localStorage.getItem(this.constStatic.APP_INFO)).topTitle;
  },
  methods:{
      logoClick(){
          // this.$store.dispatch('setMenuValueFunction', 'yxyl');
          // this.$router.push('/yxHome');
      },
      toProtal(){
          let url = this.appUtils.getDomainProtal();
          window.open(url);
      }
  },
  props: {
    title: {
      type: String,
      default: '专家工作台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style lang="less" scoped="">
    .logo-content{
      height: 100%;
      display: flex;
      align-items: center;
      img{
        height: 40px;
      }
      p{
        margin: 0;
        padding: 0;
        padding-left: 8px;
        line-height: 20px;
      };
    }
    .protalName{
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #F5222D;
    }
</style>